import { reactive } from 'vue'

// Create reactive state outside the plugin
const toastState = reactive({
  show: false,
  message: '',
  color: 'success',
  timeout: 4000
})

export default {
  install(app) {
    app.config.globalProperties.$toast = {
      success(message, timeout = 4000) {
        toastState.show = false // Hide first to reset
        setTimeout(() => {
          toastState.message = message
          toastState.color = 'success'
          toastState.timeout = timeout
          toastState.show = true
        }, 50)
      },
      
      error(message, timeout = 6000) {
        toastState.show = false
        setTimeout(() => {
          toastState.message = message
          toastState.color = 'error'
          toastState.timeout = timeout
          toastState.show = true
        }, 50)
      },
      
      warning(message, timeout = 5000) {
        toastState.show = false
        setTimeout(() => {
          toastState.message = message
          toastState.color = 'warning'
          toastState.timeout = timeout
          toastState.show = true
        }, 50)
      },
      
      info(message, timeout = 4000) {
        toastState.show = false
        setTimeout(() => {
          toastState.message = message
          toastState.color = 'info'
          toastState.timeout = timeout
          toastState.show = true
        }, 50)
      },
      
      state: toastState
    }
  }
}